import "../../../assets/css/VideoConference.css";
import { FiVideo } from "react-icons/fi";
import { MdOutlineShield } from "react-icons/md";
import PrimaryButton from "../../../components/common/PrimaryButton.js";

const CLIENT_ID = process.env.REACT_APP_ZOOM_CLIENT_ID;
const REDIRECT_URI =
  process.env.REACT_APP_ZOOM_REDIRECT_URI ||
  `${window.location.origin}/zoom/callback`;

export default function ZoomAuthSection({ connected, onDisconnect }) {
  const connectZoom = () => {
    const url =
      `https://zoom.us/oauth/authorize?response_type=code` +
      `&client_id=${CLIENT_ID}` +
      `&redirect_uri=${encodeURIComponent(REDIRECT_URI)}` +
      `&state=${encodeURIComponent(window.location.origin)}`;

    window.open(url, "Zoom OAuth", "width=500,height=650");
  };

  const logout = async () => {
    await onDisconnect();
  };

  /* ---------------- DISCONNECTED ---------------- */
  if (!connected) {
    return (
      <div className="zoom-auth-wrapper">
        <div className="zoom-auth-title">Authentication - Zoom</div>

        <div className="zoom-auth-card warning">
          <div className="zoom-auth-left">
            <div className="zoom-auth-icon warning-icon">
              <MdOutlineShield/>
            </div>

            <div>
              <div className="zoom-auth-heading">
                Connect Your Account
              </div>
              <div className="zoom-auth-subtext">
                To create and manage meetings, you need to authenticate with your Zoom account.
              </div>

              <PrimaryButton
                className="zoom-auth-btn"
                onClick={connectZoom}
              >
                Connect Zoom
              </PrimaryButton>
            </div>
          </div>
        </div>
      </div>
    );
  }

  /* ---------------- CONNECTED ---------------- */
  return (
    <div className="zoom-auth-wrapper">
      <div className="zoom-auth-title">Authentication - Zoom</div>

      <div className="zoom-auth-card success">
        <div className="zoom-auth-left">
          <div className="zoom-auth-icon success-icon">✓</div>

          <div>
            <div className="zoom-auth-heading">
              Connected
            </div>
            <div className="zoom-auth-subtext muted">
              Your Zoom account is connected
            </div>
          </div>
        </div>

        <button
          className="zoom-auth-logout"
          onClick={logout}
        >
          Logout
        </button>
      </div>
    </div>
  );
}
